export default function Footer() {
  return (
    <footer className="px-8 py-10 border-t text-sm text-gray-600 text-center">
      © {new Date().getFullYear()} Teddy’s Tallow. All rights reserved.
    </footer>
  );
}
